import { combineReducers } from 'redux';

import globals from './globals/reducers';

import feedback from './areas/feedback/reducers';
import footer from './areas/footer/reducers';
import product from './areas/product/reducer';
import productAlert from './areas/product-alert/reducers';
import category from './areas/category/reducers';
import account from './areas/account/reducers';
import navigation from './areas/navigation/reducers';
import campaign from './areas/campaign/reducers';
import ads from './components/ads/reducer';
import sidebar from './areas/sidebar/reducer';
import mobileSidebar from './areas/sidebar/components/sidebar-mobile/reducers';
import user from './areas/user/reducer';
import modal from './components/modal/reducer';
import review from './areas/reviews/reducers';
import recentlyVisited from './components/recently-visited/reducer';
import toast from './components/toast-container/reducers';
import compare from './areas/product-compare/reducers';
import productCollection from './areas/product-collection/reducers';
import coBrandingBanner from './components/co-branding-banner/reducer';
import publicList from './areas/public-list/reducers';
import changelog from './areas/changelog/reducers';
import search from './areas/search/reducers';

const areas = combineReducers({
  product,
  productAlert,
  category,
  account,
  navigation,
  campaign,
  sidebar,
  mobileSidebar,
  productCollection,
  user,
  review,
  compare,
  publicList,
  changelog,
  search,
});

const rootReducer = combineReducers({
  globals,
  feedback,
  areas,
  footer,
  ads,
  modal,
  recentlyVisited,
  toast,
  coBrandingBanner,
});

export type AppState = ReturnType<typeof rootReducer>;
export default rootReducer;
